<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      clip-rule="evenodd"
      d="M13 3C13 2.44772 12.5523 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.4477 21.5523 11 21 11C20.4477 11 20 11.4477 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C12.5523 4 13 3.55228 13 3ZM12.9933 7.88338C12.9355 7.38604 12.5128 7 12 7C11.4477 7 11 7.44772 11 8V13L11.0087 13.1314C11.0374 13.3481 11.1366 13.5508 11.2929 13.7071L13.7929 16.2071L13.8871 16.2903C14.2794 16.5953 14.8466 16.5676 15.2071 16.2071L15.2903 16.1129C15.5953 15.7206 15.5676 15.1534 15.2071 14.7929L13 12.585V8L12.9933 7.88338ZM18 3C18.5128 3 18.9355 3.38604 18.9933 3.88338L19 4V7.00228L20.3279 5.67461L20.4221 5.59142C20.8144 5.28639 21.3817 5.31412 21.7421 5.67461C22.1327 6.06513 22.1327 6.6983 21.7421 7.08882L18.7069 10.1241L18.6127 10.2073C18.2204 10.5123 17.6531 10.4846 17.2926 10.1241L14.2743 7.10579L14.1911 7.01158C13.8861 6.61929 13.9139 6.05206 14.2743 5.69158L14.3685 5.60839C14.7608 5.30336 15.3281 5.33109 15.6886 5.69158L17 7.00391V4C17 3.44772 17.4477 3 18 3Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
